import React from "react";
import { withRouter } from "react-router-dom";
import dropdownArrow from "../../../../assets/images/dropdown-arrow.svg";

import "./PowerTrainDropdown.scss";

const PowerTrainDropdown = (props) => {
  let pageRef = React.createRef();
  const handleLink = (path) => {
    props.history.push(path);
  };

  return (
    <div className="PowerTrainDropdown" ref={pageRef}>
      <ul>
        <li
          onClick={() => {
            handleLink("/combustion");
            props.onClickLi();
          }}
        >
          Combustion Engine
        </li>
        <li
          onClick={() => {
            handleLink("/combustion-engine-control");
            props.onClickLi();
          }}
        >
          Combustion <br /> Engine Control
        </li>
        <li
          onClick={() => {
            handleLink("/electric-powertrain-xev");
            props.onClickLi();
          }}
        >
          Electric <br /> Powertrain xEV
        </li>
        <li>
          Transmission/
          <br /> Transfer case
        </li>
        <div className="dropdownWrapper">
          <img src={dropdownArrow} alt="Dropdown arrow icon" />
          <div>
            <li
              onClick={() => {
                handleLink("/current-interface");
                props.onClickLi();
              }}
            >
              Current interface
            </li>
            <li
              onClick={() => {
                handleLink("/voltage-interface");
                props.onClickLi();
              }}
            >
              Voltage interface
            </li>
          </div>
        </div>
      </ul>
    </div>
  );
};

export default withRouter(PowerTrainDropdown);
